// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bct_a bhl_b bhl_va bhl_rv bhl_rw bhl_vu","PanelFooter--link":"bct_b"};